module.exports = __webpack_public_path__ + "img/slider.4458ad2b.png";